import React from 'react';
import DocumentationFolderPickerItem from './DocumentationFolderPickerItem';
import styles from './DocumentationFolderPicker.module.scss';
import { useDocumentationFoldersQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';

interface Props {
	onSelect: (id: string) => void;
	patientId: string;
}

const DocumentationFolderPicker: React.FC<Props> = ({
	onSelect,
	patientId,
}) => {
	const { data, isLoading } = useDocumentationFoldersQuery({
		userId: patientId,
	});

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{data?.documentationFolders?.data?.map(folder => {
				return (
					<DocumentationFolderPickerItem item={folder} onSelect={onSelect} />
				);
			})}
		</div>
	);
};

export default DocumentationFolderPicker;
